import ScrollMagic from "scrollmagic";
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
import lozad from "lozad";
import gsap from "gsap";
import FontFaceObserver from "fontfaceobserver";
import ScrollTrigger from "gsap/ScrollTrigger";
import {is_desktop, is_mobile} from "./utils";
import {frame_cover_animation, grid_scale, perform_scene_easing,} from "./anime";
import {frame_points} from "./points";
import {top_parallax, top_parallax_a,} from "./parallax_gallery";
import {play_box_video, set_main_video_position,} from "./video";
import {sub_menu} from "./sub_menu";
import {mobile_nav} from "./mobile_nav";
import {aos_btn_color} from "./btn-color";

const observer = lozad(".lozad", {
  rootMargin: "2000px 0px",
  threshold: 0.1,
  enableAutoReload: true,
  loaded: function () {
    ScrollTrigger.refresh(true);
    controller.update();
  },
});

observer.observe();

aos_btn_color();

let isMain = false;
let ww = window.innerWidth;
let wh = window.innerHeight;
let isDesktop = ww >= 1280;
let isTablet = ww < 1280 && ww >= 768;
let scrollingScenes = [];
let isSmallDesktop = ww >= 1280 && ww < 1600;
let isFHD = ww >= 1600 && ww <= 1920;
let isLarge = ww > 1920;
let easeScenes = [];
let updateEasingScenes = true;
let controller = new ScrollMagic.Controller();
let siryon_frame;
let sprites = [];
let motor;
let battery;
let colors;
let splits = [];

// Points for frame interactive
const points = {
  zero_in_p1: {
    from: 0,
    to: 0.1666,
  },
  zero_in_p2: {
    from: 0.1666,
    to: 0.3333,
  },
  zero_in_p3: {
    from: 0.3333,
    to: 0.5,
  },
  p1_in_p2: {
    from: 0.501,
    to: 0.6666,
  },
  p1_in_p3: {
    from: 0.6666,
    to: 0.8333,
  },
  p2_in_p3: {
    from: 0.8333,
    to: 1,
  },
};

gsap.defaults({
  ease: "linear",
  duration: 1,
  overwrite: "auto",
});

window.onload = function () {
  //If you don't want use timer and check innerHTML you can try this event
  isMain = document.querySelector(".main");

  let tempLink = document.createElement("a"),
    supportsAR = tempLink.relList.supports("ar");

  if (supportsAR) {
    $(".ar_icon, .ar_link").addClass("iOS");
  }

  if (!isMain) {
    return;
  }

  initSprites();
  adjustTabs();
  addSplit()
  changeHeaderColor();
  lazyLoadContent();
  frame_points(points, siryon_frame);
  perform_scene_easing(updateEasingScenes, easeScenes);
  observeCanvasElements();
  play_box_video(controller, scrollingScenes);
  mobile_nav();
  top_parallax(easeScenes, controller);
  top_parallax_a(easeScenes, controller);

  if (is_desktop) {
    grid_scale();
  }


  function initHallo() {
    if (window.screen.width >= 767) {
      animationHalo();
      animationDiode();

    } else {
      animationPhoneHalo();
      animationPhoneDiode();
    }
  }

  initHallo()

  $('.btn-up').click(function(){
    setTimeout(() => {
      initHallo()
    }, 1000);
  })

  $(".main-display__background img").each(() => {
    if (this.complete) {
      setImage(this);
    } else {
      $(this).on("load", function () {
        setImage(this);
      });
    }
  });

  setTimeout(() => {
    setImage($(".main-display__background img")[0]);
  }, 500);

  let resizeTimer;
  $(window).on("resize", () => {
    clearTimeout(resizeTimer);
    let widthChanged = ww !== window.innerWidth;
    ww = window.innerWidth;
    wh = window.innerHeight;

    isTablet = ww < 1280;
    isDesktop = ww >= 1280;
    isSmallDesktop = ww >= 1280 && ww < 1600;
    isFHD = ww >= 1600 && ww <= 1920;
    isLarge = ww > 1920;

    if (widthChanged) {
      resizeTimer = setTimeout(function () {
        for (let i = 0; i < scrollingScenes.length; i++) {
          if (scrollingScenes[i].update) {
            scrollingScenes[i].update();
          }
        }

        for (let i = 0; i < easeScenes.length; i++) {
          if (easeScenes[i].update) {
            easeScenes[i].update();
          }
        }

        setImage($(".main-display__background img")[0]);

        adjustTabs();

        if (!is_mobile) {
          set_main_video_position();
        }
      }, 500);
    }

    initHallo();
  });

  sub_menu(updateEasingScenes);

  if (is_mobile) {
    navboxScrollEffect();
    return;
  }

  frame_cover_animation(controller, scrollingScenes);
  set_main_video_position();
};

function loadContent() {
  if (!is_mobile) {
    let resizeTimer;
    let lastWidth = ww;
    $(window).on("resize", function (e) {
      clearTimeout(resizeTimer);
      let widthChanged = ww !== lastWidth;
      lastWidth = ww = window.innerWidth;
      wh = window.innerHeight;

      resizeTimer = setTimeout(function () {
        if (widthChanged) {
          recreateSplit();
        }
      }, 500);
    });
  }

  gsap.delayedCall(1, lazyLoadSprites);
}

function setImage(target) {
  let container = $(".main-display__display");
  if (!container.length) {
    return;
  }
  let containerWidth = container.width();
  let containerHeight = container.height();
  gsap.set(".main-display__background", {
    top: 0,
    left: 0,
    immediateRender: true,
  });
  let backgroundContainerBox = document
    .querySelector(".main-display__background")
    .getBoundingClientRect();
  let originalWidth = (100 * containerWidth) / 12.78;
  let originalHeight = (100 * containerHeight) / 17.97;
  let leftDistance = (originalWidth / 100) * 44.51;
  let topDistance = (originalHeight / 100) * 47.54;

  let bottomDistance = (originalHeight / 100) * 34.49;
  let paddingBottom = wh - (wh * 0.2 + containerHeight);
  paddingBottom = is_mobile ? wh - (wh * 0.4 + containerHeight) : paddingBottom;
  paddingBottom = Math.min(bottomDistance, paddingBottom);

  gsap.set(".main-display__in", {
    paddingTop: topDistance / 1.5,
    paddingBottom: Math.min(300, bottomDistance),
    minHeight: containerHeight,
  });

  let bgHeight = originalHeight + bottomDistance - paddingBottom;

  bgHeight = is_mobile ? originalHeight : bgHeight;

  gsap.set(".main-display__background img", {
    top: 0,
    left: -leftDistance + backgroundContainerBox.left,
    width: originalWidth,
    height: originalHeight,
  });

  gsap.set(".main-display__background", {
    top: -topDistance,
    left: -backgroundContainerBox.left,
    width: $(window).width(),
    height: bgHeight,
  });

  gsap.set(target, {
    opacity: 1,
  });
}

function adjustTabs() {
  if (!is_mobile) {
    let batteryHeadingHeight = 0;
    let $batteryTabs = $(".battery__tabs h3");
    $batteryTabs.each(function (i, heading) {
      batteryHeadingHeight = Math.max(
        batteryHeadingHeight,
        $(heading).height()
      );
    });
    $batteryTabs.height(batteryHeadingHeight);
  }

  $(".tabs__content").each(function (i, tab) {
    let maxHeight = 0;

    $(tab)
      .find(".tab-pane")
      .each(function (i, pane) {
        let newHeight = $(pane).height();
        maxHeight = maxHeight > newHeight ? maxHeight : newHeight;
      });

    $(tab).height(maxHeight).find(".tab-pan").height(maxHeight);
  });
}

// function getSprite(name) {
//     if (!sprites) return;
//     for (let i = 0; i < sprites.length; i++) {
//         if (sprites[i] && sprites[i].name === name) {
//             return sprites[i];
//         }
//     }
//
//     return null;
// }

function observeCanvasElements() {
  let spriteObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach(function (entry) {
        // let spriteName = $(entry.target).data("sprite");
        // let sprite = getSprite(spriteName);
        if (entry.isIntersecting) {
          for (let i = 0; i < easeScenes.length; i++) {
            if (easeScenes[i].isSprite) {
              easeScenes[i].follower.render(
                easeScenes[i].follower.time(),
                false,
                true
              );
            }
          }
        }
      });
    },
    {
      root: null,
      rootMargin: "200px",
      threshold: 0,
    }
  );

  $("[data-sprite]").each(function (i, elem) {
    spriteObserver.observe(elem);
  });
}

function addEmptySpans() {
  $(".splitScroll span").each(function (i, elem) {
    let className = elem.className;
    let spanText = $(elem).text();
    let split = spanText.split(" ");
    let html = "";

    for (let i = 0; i < split.length; i++) {
      let text = split[i];
      html += "<span class='" + className + "' >" + text + "</span>";
      if (i !== split.length - 1) html += "<span class='empty'> </span>";
    }

    $(elem).replaceWith(html);
  });
}

function createSplitTimeline(elem) {
  let split = new SplitText(elem, {
    type: "lines, words",
    linesClass: "lines",
  });
  let spacing = [];
  for (let j = 0; j < split.lines.length; j++) {
    spacing.push(j * 40);
  }
  let tl = gsap.timeline({}).fromTo(
    split.lines,
    {
      yPercent: gsap.utils.wrap(spacing),
      immediateRender: true,
    },
    {
      yPercent: 0,
      duration: 0.5,
      ease: "slow",
    }
  );
  return {
    tl: tl,
    split: split,
  };
}

function addSplit() {
  addEmptySpans();

  let paragraphs = $(".splitScroll");

  paragraphs.each(function (i, elem) {
    let splitObj = createSplitTimeline(elem);
    let tween = splitObj.tl;
    let split = splitObj.split;
    let scene = new ScrollMagic.Scene({
      triggerElement: elem,
      triggerHook: 0.8,
    })
      .setTween(tween)
      .addTo(controller);

    splits.push({
      tween: tween,
      split: split,
      scene: scene,
      elem: elem,
    });
  });
}

function recreateSplit() {
  for (var i = 0; i < splits.length; i++) {
    var split = splits[i];
    var elem = split.elem;
    split.split.revert();
    var splitObj = createSplitTimeline(elem);
    split.split = splitObj.split;
    split.tween = splitObj.tl;

    try {
      split.scene.setTween(split.tween);
    } catch (e) {
    }
  }
}

function lazyLoadSprites() {
  let totalLoaded = 0;

  for (let i = 0; i < sprites.length; i++) {
    let videoSprite = sprites[i];
    if (videoSprite.videoLoaded) {
      totalLoaded++;
    } else {
      videoSprite.load(lazyLoadSprites);
      break;
    }
  }
}

function lazyLoadContent() {
  let imgObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.src = $(entry.target).data("src");
          if (entry.target.tagName === "video") entry.target.load();
          imgObserver.unobserve(entry.target);
        }
      });
    },
    {
      root: null,
      rootMargin: "500px",
      threshold: 0,
    }
  );

  $("video[data-src],img[data-src]").each(function (i, elem) {
    imgObserver.observe(elem);
  });

  lazyLoadSprites();
}

function navboxScrollEffect() {
  let lastScrollTop = 0;
  let $window = $(window);
  let headerHeight = $(".header").height();

  let tl = gsap
    .timeline({
      paused: true,
      onReverseComplete: function () {
        gsap.delayedCall(3, function () {
          if (
            $window.scrollTop() > wh &&
            !$(".header__burger").hasClass("is-animated")
          ) {
            tl.play();
          }
        });
      },
    })
    .to(".header", {
      scaleY: 0,
      transformOrigin: "50% 0%",
      duration: 0.3,
      ease: "power2.inOut",
    })
    .to(
      ".main__navbox",
      {
        y: -headerHeight,
        duration: 0.3,
        ease: "power2.inOut",
      },
      0
    );

  $window.on("scroll", function () {
    let st = $window.scrollTop();
    if (st > lastScrollTop && st > wh / 2 && updateEasingScenes) {
      tl.play();
    } else if (updateEasingScenes) {
      tl.reverse();
    }
    lastScrollTop = st;
  });
}

function changeHeaderColor() {
  let header = document.querySelector('header.header');
  if (!header) {
    return;
  }

  let tl = gsap
    .timeline({
      paused: true,
      defaults: {
        duration: 0.5,
        ease: "sine.inOut",
      },
    })
    .to(
      ".header, .menu",
      {
        backgroundColor: "black",
      },
      0
    )
    .to(
      ".btn-up",
      {
        backgroundColor: "#474747",
      },
      0
    )
    .to(
      ".header__logo, .navbox .model",
      {
        filter: "invert(100%)",
      },
      0
    )
    .to(
      ".header__nav ul li a, .menu__in ul li a",
      {
        color: "#fff",
      },
      0
    )
    .to(
      ".header__controls svg *",
      {
        fill: "#fff",
      },
      0
    )
    .to(
      ".header__burger i",
      {
        background: "#fff",
      },
      0
    )
    .to(
      ".navbox",
      {
        background: "rgba(71, 71, 71, 0.5)",
      },
      0
    )
    .to(
      ".navbox ul li a",
      {
        color: "#fff",
      },
      0
    )
    .to(
      ".buy-btn",
      {
        background: "#fff",
        autoAlpha: 1,
      },
      0
    );

  if (!is_mobile) {
    // tl.to(".navbox--buy b", {
    //     filter: "invert(100%)"
    // }, 0)
  }

  let blackScene = new ScrollMagic.Scene({
    triggerElement: ".dark-trigger",
    triggerHook: header.clientHeight / window.innerHeight,
  })
    // .addIndicators()
    .on("enter", function () {
      tl.play();
    })
    .on("leave", function () {
      tl.reverse();
    })
    .addTo(controller);

  $(window).on("resize", function () {
    blackScene.triggerHook = header.clientHeight / window.innerHeight;
  });

  new ScrollMagic.Scene({
    triggerElement: ".frame-kit",
    triggerHook: 0,
  })
    .on("enter", function () {
      tl.reverse();
    })
    .on("leave", function () {
      tl.play();
    })
    .addTo(controller);
}

function animationHalo() {
  // model-range
  gsap.to(".product-halo .model-range-wrap", {
    scrollTrigger: {
      trigger: ".product-halo .model-range-trigger",
      start: "top top",
      end: "bottom top",
      scrub: true,
    },
    duration: 0.5,
    scale: 1.5,
    ease: "none",
  });
  gsap.to(".product-halo .model-range-wrap", {
    scrollTrigger: {
      trigger: ".product-halo .model-range-trigger",
      start: "bottom center",
      end: "bottom center",
      scrub: true,
    },
    duration: 0.5,
    opacity: 0,
    ease: "none",
  });

  // parallelogram
  gsap.to(".product-halo__triangle", {
    scrollTrigger: {
      trigger: ".product-halo .model-range-trigger",
      start: "top top",
      end: "bottom center",
      scrub: true,
    },
    duration: 0.5,
    opacity: 1,
    ease: "none",
  });
  gsap.to(".product-halo .triangle-tl", {
    scrollTrigger: {
      trigger: ".product-halo .sticky-track",
      start: "top center",
      end: "bottom 400px",
      scrub: true,
    },
    duration: 0.5,
    right: 'calc(100% + 20dvh)',
    ease: "none",

  });
  gsap.to(".product-halo .triangle-br", {
    scrollTrigger: {
      trigger: ".product-halo .sticky-track",
      start: "top center",
      end: "bottom 400px",
      scrub: true,
    },
    duration: 0.5,
    left: 'calc(100% + 20dvh)',
    ease: "none",
  });
  gsap.to(".product-halo__title", {
    scrollTrigger: {
      trigger: ".product-halo .sticky-track",
      start: "top top",
      end: "bottom 300px",
      scrub: true,
    },
    duration: 0.5,
    fontSize: '94px',
    ease: "none",
  });

  // bike width
  gsap.to(".product-halo .sticky-box__img", {
    scrollTrigger: {
      trigger: ".product-halo .sticky-box",
      start: "top top",
      end: "center 70%",
      scrub: true,
      markers: true,
    },
    width: '50%',
    duration: 1,
    ease: "none",
  });
  gsap.to(".product-halo .sticky-box__img--wrap", {
    scrollTrigger: {
      trigger: ".product-halo .sticky-box",
      start: "top top",
      end: "center 70%",
      scrub: true,
      markers: true,
    },
    // height: '60vh',
    height: '100%',
    duration: 1,
    ease: "none",
  });

  // slider
  gsap.to(".halo-img-2", {
    ease: 'none',
    duration: 0.5,
    scrollTrigger: {
      trigger: ".product-halo .sticky-box-wrap .wrapper",
      start: "10% top",
      end: "bottom bottom",
      scrub: true,
    },
    visibility: 'visible'
  });
  gsap.to(".halo-img-3", {
    ease: 'none',
    duration: 0.5,
    scrollTrigger: {
      trigger: ".product-halo .sticky-box-wrap .wrapper",
      start: "40% top",
      end: "bottom bottom",
      scrub: true,
    },
    visibility: 'visible'
  });
}

function animationPhoneHalo() {
  // slider
  gsap.to(".halo-img-2", {
    ease: 'none',
    duration: 0.5,
    scrollTrigger: {
      trigger: ".product-halo .sticky-box__img",
      start: "center top",
      end: "bottom bottom",
      scrub: true,
    },
    visibility: 'visible'
  });
  gsap.to(".halo-img-3", {
    ease: 'none',
    duration: 0.5,
    scrollTrigger: {
      trigger: ".product-halo .sticky-box__img",
      start: "140% top",
      end: "140% bottom",
      scrub: true,
    },
    visibility: 'visible'
  });

  gsap.to(".product-halo .sticky-box__text .text-1", {
    ease: 'none',
    duration: 0.5,
    scrollTrigger: {
      trigger: ".product-halo .sticky-box",
      start: "20% center",
      end: "60% center",
      scrub: true,
    },
    marginBottom: 30,
  });
  gsap.to(".product-halo .sticky-box__text .text-2", {
    ease: 'none',
    duration: 0.5,
    scrollTrigger: {
      trigger: ".product-halo .sticky-box",
      start: "30% center",
      end: "70% center",
      scrub: true,
    },
    marginBottom: 30,
  });
  gsap.to(".product-halo .sticky-box__text .text-3", {
    ease: 'none',
    duration: 0.5,
    scrollTrigger: {
      trigger: ".product-halo .sticky-box",
      start: "40% center",
      end: "80% center",
      scrub: true,
    },
    marginBottom: 30,
  });
  gsap.to(".product-halo .sticky-box__text .text-4", {
    ease: 'none',
    duration: 0.5,
    scrollTrigger: {
      trigger: ".product-halo .sticky-box",
      start: "50% center",
      end: "90% center",
      scrub: true,
    },
    marginBottom: 30,
  });
  gsap.to(".product-halo .sticky-box__text .text-5", {
    ease: 'none',
    duration: 0.5,
    scrollTrigger: {
      trigger: ".product-halo .sticky-box",
      start: "50% center",
      end: "90% center",
      scrub: true,
    },
    marginBottom: 30,
  });
}


function animationDiode() {

  // parallelogram
  gsap.to(".product-diode__triangle", {
    scrollTrigger: {
      trigger: ".product-diode .model-range-trigger",
      start: "top top",
      end: "bottom center",
      scrub: true,
    },
    duration: 0.5,
    opacity: 1,
    ease: "none",
  });
  gsap.to(".product-diode .triangle-tl", {
    scrollTrigger: {
      trigger: ".product-diode .sticky-track",
      start: "top center",
      end: "bottom 400px",
      scrub: true,
    },
    duration: 0.5,
    right: 'calc(100% + 20dvh)',
    ease: "none",

  });
  gsap.to(".product-diode .triangle-br", {
    scrollTrigger: {
      trigger: ".product-diode .sticky-track",
      start: "top center",
      end: "bottom 400px",
      scrub: true,
    },
    duration: 0.5,
    left: 'calc(100% + 20dvh)',
    ease: "none",
  });
  gsap.to(".product-diode__title", {
    scrollTrigger: {
      trigger: ".product-diode .sticky-track",
      start: "top top",
      end: "bottom 300px",
      scrub: true,
    },
    duration: 0.5,
    fontSize: '94px',
    ease: "none",
  });

  // bike width
  gsap.to(".product-diode .sticky-box__img", {
    scrollTrigger: {
      trigger: ".product-diode .sticky-box",
      start: "top top",
      end: "center 70%",
      scrub: true,
      markers: true,
    },
    width: '50%',
    duration: 1,
    ease: "none",
  });
  gsap.to(".product-diode .sticky-box__img--wrap", {
    scrollTrigger: {
      trigger: ".product-diode .sticky-box",
      start: "top top",
      end: "center 70%",
      scrub: true,
      markers: true,
    },
    // height: '60vh',
    height: '100%',
    duration: 1,
    ease: "none",
  });

  // slider
  gsap.to(".diode-img-2", {
    ease: 'none',
    duration: 0.5,
    scrollTrigger: {
      trigger: ".product-diode .sticky-box-wrap .wrapper",
      start: "10% top",
      end: "bottom bottom",
      scrub: true,
    },
    visibility: 'visible'
  });
  gsap.to(".diode-img-3", {
    ease: 'none',
    duration: 0.5,
    scrollTrigger: {
      trigger: ".product-diode .sticky-box-wrap .wrapper",
      start: "40% top",
      end: "bottom bottom",
      scrub: true,
    },
    visibility: 'visible'
  });
}

function animationPhoneDiode() {
  // slider
  gsap.to(".diode-img-2", {
    ease: 'none',
    duration: 0.5,
    scrollTrigger: {
      trigger: ".product-diode .sticky-box__img",
      start: "center top",
      end: "bottom bottom",
      scrub: true,
    },
    visibility: 'visible'
  });
  gsap.to(".diode-img-3", {
    ease: 'none',
    duration: 0.5,
    scrollTrigger: {
      trigger: ".product-diode .sticky-box__img",
      start: "140% top",
      end: "140% bottom",
      scrub: true,
    },
    visibility: 'visible'
  });
  gsap.to(".product-diode .sticky-box__text .text-1", {
    ease: 'none',
    duration: 0.5,
    scrollTrigger: {
      trigger: ".product-diode .sticky-box",
      start: "20% center",
      end: "60% center",
      scrub: true,
    },
    marginBottom: 30,
  });
  gsap.to(".product-diode .sticky-box__text .text-2", {
    ease: 'none',
    duration: 0.5,
    scrollTrigger: {
      trigger: ".product-diode .sticky-box",
      start: "30% center",
      end: "70% center",
      scrub: true,
    },
    marginBottom: 30,
  });
  gsap.to(".product-diode .sticky-box__text .text-3", {
    ease: 'none',
    duration: 0.5,
    scrollTrigger: {
      trigger: ".product-diode .sticky-box",
      start: "40% center",
      end: "80% center",
      scrub: true,
    },
    marginBottom: 30,
  });
  gsap.to(".product-diode .sticky-box__text .text-4", {
    ease: 'none',
    duration: 0.5,
    scrollTrigger: {
      trigger: ".product-diode .sticky-box",
      start: "50% center",
      end: "90% center",
      scrub: true,
    },
    marginBottom: 30,
  });
  gsap.to(".product-diode .sticky-box__text .text-5", {
    ease: 'none',
    duration: 0.5,
    scrollTrigger: {
      trigger: ".product-diode .sticky-box",
      start: "50% center",
      end: "90% center",
      scrub: true,
    },
    marginBottom: 30,
  });
}

function initSprites() {
  if (!is_mobile && document.querySelectorAll(".main__video video").length) {
    let mainVideoPlayed = false;
    let mainVideoLoaded = false;
    let main_video = $(".main__video video");
    let mainVideoIsPlaying = false;
    let playVideoTimer;
    let autoPlayAttempts = 0;
    let bikeTitleAnimation = gsap.fromTo(
      ".main__bike",
      {
        yPercent: 100,
        opacity: 1,
      },
      {
        yPercent: 0,
        paused: true,
        duration: 1.2,
        ease: "power2.out",
      }
    );
    let videoSource = main_video.find("source").data("src");
    main_video.attr("src", videoSource);
    main_video[0].load();
    // if video is cached then directly play video
    if (main_video[0].readyState === 4) {
      main_video[0].play();
    } else {
      // adds event to play video when it is ready
      main_video.on("canplaythrough", function () {
        if (mainVideoLoaded) return;
        mainVideoLoaded = true;
        main_video[0].play();
      });
    }

    // once video is done playing, check if font has loaded
    main_video[0].addEventListener("ended", function () {
      if (mainVideoPlayed) return;
      mainVideoPlayed = true;
      gsap
        .timeline()
        .set(".main__video img", {
          display: "block",
          position: "absolute",
          opacity: 1,
        })
        .to(main_video, {
          display: "none",
          opacity: 0,
          duration: 5,
        })
        .set(".main__video img", {
          display: "block",
          position: "relative",
          opacity: 1,
        });
      loadContent();
    });
    main_video[0].addEventListener("timeupdate", function () {
      if (main_video[0].currentTime >= 2) {
        bikeTitleAnimation.play();
      }
    });

    main_video[0].addEventListener("playing", function () {
      mainVideoIsPlaying = true;
    });

    playVideoTimer = setInterval(function () {
      autoPlayAttempts++;
      if (
        !mainVideoPlayed &&
        main_video[0].readyState === 4 &&
        !mainVideoIsPlaying
      ) {
        main_video[0].play();
      } else if (mainVideoPlayed) {
        clearInterval(playVideoTimer);
      }

      if (autoPlayAttempts > 7 && !mainVideoIsPlaying) {
        clearInterval(playVideoTimer);
        gsap
          .timeline()
          .set(main_video, {
            display: "none",
          })
          .fromTo(
            ".main__video img",
            {
              opacity: 0,
              display: "block",
            },
            {
              display: "block",
              opacity: 1,
            }
          )
          .add(bikeTitleAnimation.play());
        loadContent();
      }
    }, 2000);
  } else {
    loadContent();
  }

  if (!is_mobile) {
    let font = new FontFaceObserver("Object Sans", {
      weight: 700,
    });

    font.load("", 10000).then(
      function () {
        addSplit();
      },
      function () {
        console.log("failed to load font");
        addSplit();
      }
    );
  }
}
